import React from 'react';
import styles from '../ReportCard.module.scss';

/**
 * Три модальных окна статуса: Success / Error / Warning.
 */
const StatusModals = ({
  showSuccessModal, successModalData, onCloseSuccess,
  showErrorModal, errorModalData, onCloseError,
  showWarningModal, warningModalData, onCloseWarning,
}) => {
  return (
    <>
      {/* Успех */}
      {showSuccessModal && successModalData && (
        <div className={styles.successModalOverlay}>
          <div className={styles.successModalContent}>
            <div className={styles.successModalHeader}>
              <div className={styles.successIcon}>✓</div>
              <h2 className={styles.successTitle}>
                {successModalData.actionType === 'guard_exit'
                  ? 'Выезд с базы подтверждён — Водитель в пути'
                  : successModalData.actionType === 'exit'
                  ? 'Погрузка успешно завершена и принята'
                  : 'Успешно подтверждён въезд в базу'}
              </h2>
            </div>
            <div className={styles.successModalBody}>
              <ModalDataRow label="ФИО" value={successModalData.fio} prefix="success" />
              <ModalDataRow label="Телефон" value={successModalData.phone} prefix="success" />
              <ModalDataRow label="Авто номер" value={successModalData.vehicleNumber} prefix="success" />
              <ModalDataRow label="База" value={successModalData.base} prefix="success" />
            </div>
            <div className={styles.successModalFooter}>
              <button onClick={onCloseSuccess} className={styles.successCloseBtn}>Продолжить</button>
            </div>
          </div>
        </div>
      )}

      {/* Ошибка */}
      {showErrorModal && errorModalData && (
        <div className={styles.errorModalOverlay}>
          <div className={styles.errorModalContent}>
            <div className={styles.errorModalHeader}>
              <div className={styles.errorIcon}>✖</div>
              <h2 className={styles.errorTitle}>{errorModalData.reason}</h2>
            </div>
            <div className={styles.errorModalBody}>
              <ModalDataRow label="ФИО" value={errorModalData.fio} prefix="error" />
              <ModalDataRow label="Телефон" value={errorModalData.phone} prefix="error" />
              <ModalDataRow label="Авто номер" value={errorModalData.vehicleNumber} prefix="error" />
              <ModalDataRow label="База" value={errorModalData.base} prefix="error" />
              <div className={styles.errorMessage}>
                СООБЩИТЕ АДМИНИСТРАЦИИ О НАРУШЕНИИ
                <br />
                <strong>0600011032</strong>
              </div>
            </div>
            <div className={styles.errorModalFooter}>
              <button onClick={onCloseError} className={styles.errorCloseBtn}>Закрыть</button>
            </div>
          </div>
        </div>
      )}

      {/* Предупреждение */}
      {showWarningModal && warningModalData && (
        <div className={styles.warningModalOverlay}>
          <div className={styles.warningModalContent}>
            <div className={styles.warningModalHeader}>
              <div className={styles.warningIcon}>⚠</div>
              <h2 className={styles.warningTitle}>{warningModalData.title}</h2>
            </div>
            <div className={styles.warningModalBody}>
              <p className={styles.warningText}>{warningModalData.message}</p>
              <p className={styles.warningSubtext}>
                <strong>База:</strong> {warningModalData.distance}
              </p>
              <p className={styles.warningSubtext}>{warningModalData.requirement}</p>
            </div>
            <div className={styles.warningModalFooter}>
              <button onClick={onCloseWarning} className={styles.warningCloseBtn}>Понятно</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

/** Строка данных в модальном окне */
const ModalDataRow = ({ label, value, prefix }) => (
  <div className={styles[`${prefix}DataItem`]}>
    <span className={styles[`${prefix}Label`]}>{label}:</span>
    <span className={styles[`${prefix}Value`]}>{value}</span>
  </div>
);

export default React.memo(StatusModals);
